import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { ErrorPage } from "./Page/ErrorPage";
import { Home } from "./Page/Home";

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<ErrorPage/>} />
    </Routes>
  </BrowserRouter>
  
  );
}

export default App;
